module.exports = __webpack_public_path__ + "static/media/genisis7.a66f45b8.jpg";